<template>
    <div>
        <div id="splash-background"></div>
        <div id="splash-display">
            <dh-logo size="250px"/>
        </div>
    </div>
</template>

<script>
  import DhLogo from "./_icons/DhLogo";

  export default {
    name: "SplashScreen",
    components: {DhLogo},
  }
</script>

<style scoped>
    /* ANIMATIONS */

    @keyframes scaleUp {
        0% {
            opacity: 1;
            transform: scale(1);
        }

        /* keyframes 99 & 100 are used with `display` due to dh-logo hiding all instances if using `visibility` */

        99% {
            opacity: 0;
            display: none;
            transform: scale(1.2);
        }
        100% {
            opacity: 0;
            display: none;
            transform: scale(0);
        }
    }

    @keyframes fadeBackground {
        0% {
            background-color: rgba(51,51,51,.7);
            visibility: visible;
            cursor: wait;
        }
        100% {
            background-color: transparent;
            visibility: hidden;
            cursor: default;
        }
    }

    /* STYLE */

    #splash-background {
        z-index: 3000;
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;

        animation: 1.5s ease-in-out 0s 1 fadeBackground;
        animation-fill-mode: forwards;
    }

    #splash-display {
        z-index: 3000;
        position: absolute;
        left: calc(50% - 125px);
        top: calc(50% - 125px);

        animation: 1s ease-in-out 0s 1 scaleUp;
        animation-fill-mode: forwards;
    }

    /*#splash-text {*/
        /*font-size: 30pt;*/
        /*font-family: var(--font-montserrat);*/
        /*text-align: center;*/
    /*}*/
</style>
